<script lang="ts">
  import ProductPrice from '$lib/components/product/ProductPrice.svelte'
	import ProductPromoBanner from './ProductPromoBanner.svelte'
  import Trustpilot from '$lib/components/partials/Trustpilot.svelte'
  import ProductTags from '$lib/components/product/ProductTags.svelte'
	import {
		getProductSpecialPriceWithTax,
		getUniverseInfo,
		isSequraActive,
		getProductRegularPriceWithTax,
		getProductTierPriceWithTax,
	} from '$lib/js/helpers'
  import { page } from '$app/state';
	import type { FullProduct } from '$lib/js/elasticsearch/types'

  interface Props {
    product: FullProduct;
  }

  let { product }: Props = $props();
  let qtyselected = $state(1);
  
  let special_price = $derived(() => getProductSpecialPriceWithTax(product))
  let regular_price = $derived(() => getProductRegularPriceWithTax(product))

  /* Special tier prices */
  let total_price = $derived(() => {
    if (getProductTierPriceWithTax(product, qtyselected)) {
      return getProductTierPriceWithTax(product, qtyselected) * (qtyselected || 1)
    } else if (special_price() && special_price() < regular_price()) {
      return special_price() * qtyselected
    } else {
      return regular_price() * qtyselected
    }
  });

  let universe_info = $derived(() => {
    return getUniverseInfo(
      page.data?.universes_menu?.universes,
      page.data?.category?.url_path?.split("/")[1]
    )
  })
</script>


<div style="--univ-main: {universe_info()?.color || '#f0f0f0'}" class="product-data">
  <div class="tags">
    <ProductTags tags={product.tags}/>
  </div>
  <h1 class="title head-4">{product.name}</h1>

  <ProductPrice {product} bind:qtyselected={qtyselected}/>

  <!-- FIXME the price must be in cents

    Example warning:
      [SeQura] Invalid amount 9.949999400000001, expected cents. Using 994 as amount
  -->
  {#if total_price()}
    <div class="sequra-info">
      {#if isSequraActive(page.data?.settings, product.category_ids)}
        <div
          class="sequra-promotion-widget"
          data-amount={total_price()}
          data-product="pp3"
          data-size="S"
          data-branding="black"
        ></div>

        <span
          class="sequra-educational-popup"
          data-amount={total_price()}
          data-product="pp3"
        ></span>
      {/if}
    </div>
  {/if}

  <div class="trustpilot">
    <Trustpilot/>
  </div>

  {#if page.data?.promo_banner}
    <ProductPromoBanner banners={page.data.promo_banner} manufacturer={product.manufacturer}/>
  {/if}
</div>


<style lang="scss">
  .product-data {
    background: var(--grey);
    background: var(--univ-main);
    padding: 30px 20px;
    height: calc(100% - 60px);
    margin: 0 -20px;
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media (min-width: 769px) {
      margin: 0;
      padding: 30px;
    }

    .tags {
      margin-bottom: 15px;
    }

    .title {
      margin-bottom: 20px;
      line-height: 1.2;
      word-break: break-word;
      font-size: 28px;

      @media (max-width: 768px) {
        font-size: 20px;
        line-height: 1.3;
      }
    }

    // .payment {
    //   @media (min-width: 769px) {
    //     margin-top: 10px;
    //   }
    // }

    .trustpilot {
      margin-top: 20px;
    }

    .sequra-info {
      margin-top: 18px;
    }

    .sequra-promotion-widget {
      max-height: 65px;

      @media (min-width: 1200px) {
        max-height: 50px;
      }
    }
  }
</style>
